<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />{{ userStore.user.ssn }}
            <br/>{{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p class="letter-content">
            Subject: THIRD Request Dispute of Late Payments on My Consumer report.
        </p>
        <p class="letter-content">
            Notice to Agent is notice to principal notice to principal is notice to agent.
        </p>
        <p class="letter-content">
            I have received a copy on my consumer reports and I notice you have furnished transactions on my consumer report that is excluded by law as per the FCRA 15 USC 1681a 2Ai.
        </p>
        <p class="letter-content">
            (2)Exclusions.—Except as provided in paragraph (3), the term "consumer report" does not include—
        </p>
        <p class="letter-content">
            (i) report containing information solely as to transactions or experiences between the consumer and the person making the report;
        </p>
        <p class="letter-content">
            A consumers transactions are excluded from the consumer reports. FICO and or any other Risk score or algorithm that you use to calculate a consumers credit score is not a 
            factor where the consumer report is concerned! Definition of what the consumer report means.
        </p>
        <p class="letter-content">
            consumer report
            <br/>
             (1) In general .— The term "consumer report" means any written, oral, or other communication of any information by a consumer reporting agency bearing on a consumer's credit 
            worthiness, credit standing, credit capacity, character, general reputation, personal characteristics, or mode of living which is used or expected to be used or collected in 
            whole or in part for the purpose of serving as a factor in establishing the consumer's eligibility for— (A) credit or insurance to be used primarily for personal, family, or 
            household purposes; (B) employment purposes; or (C) any other purpose authorized under section 1681b of this title.
        </p>
        <p class="letter-content">
            FICO or non of its factors are not defined or included in the definition of the consumer report! Therefore the reporting of transactions regarding (ME) the consumer is a violation 
            of 15 USC 1681a the definition of the consumer report does not include FICO or Vantage which makes their factors or algorithm not a factor where the consumer report is concerned.
        </p>
        <p class="letter-content">
            You have furnished transaction information on the following accounts.
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>
        <p class="letter-content">
            15 USC 1666b<br/>
            (a)Time to make payments<br/>
            A creditor may not treat a payment on a credit card account under an open end consumer credit plan as late for any purpose.
        </p>
        <p>
            Best regards,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                address,
            };
        },
    };
</script>
